(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('TaskObjectTypeSearch', TaskObjectTypeSearch);

    TaskObjectTypeSearch.$inject = ['$resource'];

    function TaskObjectTypeSearch($resource) {
        var resourceUrl =  'api/_search/task-object-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
